import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageTab from 'shared/components/page-tab/page-tab';
import Routes from 'shared/enums/routes';

const IntegrationsNavigation: React.FC = () => {
  const { t } = useTranslation('integrations');
  const navigate = useNavigate();

  return (
    <PageTab
      onPageChanged={(link: string) => navigate(link)}
      mainRoute={Routes.Integrations}
      pageTabs={[
        {
          subRoute: Routes.IntegrationsDevices,
          title: t('pageTab.devicesLabel'),
        },
        {
          subRoute: Routes.IntegrationsSystems,
          title: t('pageTab.systemsLabel'),
        },
        {
          subRoute: Routes.IntegrationsGateways,
          title: t('pageTab.gatewaysLabel'),
        },
        {
          subRoute: Routes.IntegrationsConnectors,
          title: t('pageTab.connectorsLabel'),
        },
      ]}
    />
  );
};

export default IntegrationsNavigation;
